import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { actions as formActions } from 'ducks/form';
import { selectors as productionOrderSelectors, actions as productionOrderActions } from 'ducks/purchaseOrderEnquiry/committedProductionOrder';
import { search } from 'api/purchaseOrderEnquiry/committedProductionOrder';
import { selectors as orderSelectors } from 'ducks/purchaseOrderEnquiry/purchaseOrder';
import { actions as orderLineActions } from 'ducks/purchaseOrderEnquiry/purchaseOrderLine';

const params = new URLSearchParams(location.search);

export const mapStateToProps = state => ({
  gridName: 'CommittedProductionOrder',
  columnDefs: productionOrderSelectors.Columns(state),
  isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state), //to trigger update size based on drawer state change
  actions: productionOrderSelectors.Actions(state),
  gridOptions: productionOrderSelectors.gridOptions(state),
  isLoading: productionOrderSelectors.isLoading(state),
  apiMethod: search,
  reqParams: (orderSelectors.selected(state) || params.get('PurchaseOrder')) &&
    {
      PurchaseOrder: (orderSelectors.selected(state) && orderSelectors.selected(state).PurchaseOrder) || params.get('PurchaseOrder'),
    },
  keyFields: [{ valueField: 'PurchaseOrderLineNumber', routeField: 'LineNumber' }],
});

export const actions = {
  deleteSelectedRecords: productionOrderActions.remove,
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  setSelectedOrderLine: orderLineActions.setSelected
}
